import { SUPERBUILDER_SELECT, SUPERBUILDER_MANDATORY_STATUS } from '../Actions/SuperBuilder.action';

const defaultState = {
    selectedCombinedSuperBuilderKeys: [],
    mandatorySectionsValid: false,
}

export const superBuilder = (state = defaultState, action) => {
    switch (action.type) {
        case SUPERBUILDER_SELECT:
            return {
                ...state,
                selectedCombinedSuperBuilderKeys : action.payload,
            };
            case SUPERBUILDER_MANDATORY_STATUS: 
            return {
                ...state,
                mandatorySectionsValid : action.payload
            }
        default:
            return state;
    }
}